module.exports = __webpack_public_path__ + "17cb7a58ccd54c3c1aca47cd06abc4d2.svg";